/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MedicalSystemBeamLimitingDeviceType = {
    ElektaGammaKnife: 'Elekta_GammaKnife',
    ElektaMlci: 'Elekta_MLCi',
    ElektaMlci2: 'Elekta_MLCi2',
    ElektaBeamModulator: 'Elekta_BeamModulator',
    ElektaAgility: 'Elekta_Agility',
    ElektaHarmony: 'Elekta_Harmony',
    ElektaUnity: 'Elekta_Unity',
    VarianMlc52: 'Varian_MLC52',
    VarianMlc80: 'Varian_MLC80',
    VarianMlc120: 'Varian_MLC120',
    VarianHdmlc120: 'Varian_HDMLC120',
    VarianHalcyon: 'Varian_Halcyon',
    AccurayFixedCollimators: 'Accuray_FixedCollimators',
    AccurayIris: 'Accuray_Iris',
    AccurayIncise: 'Accuray_INCISE',
    AccurayTomoTherapy: 'Accuray_TomoTherapy',
    AccurayRadixact: 'Accuray_Radixact',
    BrainlabM3Mlc: 'Brainlab_m3_MLC',
    ViewRayMrIdian: 'ViewRay_MRIdian',
    IntraOpMobetron: 'IntraOp_Mobetron',
    SitLiac: 'SIT_LIAC',
    SitNovac11: 'SIT_NOVAC11',
    MdsTheratron: 'MDS_Theratron',
    UjpTerabalt: 'UJP_TERABALT',
    BestGammaBeam: 'Best_GammaBeam',
    PanaceaBhabhatron: 'Panacea_BHABHATRON',
    AkesisAkesisGalaxy: 'Akesis_AkesisGalaxy',
    XcisionGammaPod: 'Xcision_GammaPod',
    ZapZapX: 'Zap_Zap_X',
    OtherBeamlimitingDeviceType: 'OtherBeamlimitingDeviceType',
    MsMdsNordion: 'MS_MDS_Nordion'
} as const;
export type MedicalSystemBeamLimitingDeviceType = typeof MedicalSystemBeamLimitingDeviceType[keyof typeof MedicalSystemBeamLimitingDeviceType];


export function MedicalSystemBeamLimitingDeviceTypeFromJSON(json: any): MedicalSystemBeamLimitingDeviceType {
    return MedicalSystemBeamLimitingDeviceTypeFromJSONTyped(json, false);
}

export function MedicalSystemBeamLimitingDeviceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemBeamLimitingDeviceType {
    return json as MedicalSystemBeamLimitingDeviceType;
}

export function MedicalSystemBeamLimitingDeviceTypeToJSON(value?: MedicalSystemBeamLimitingDeviceType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the MedicalSystemBeamLimitingDeviceType interface.
 */
 export function instanceOfMedicalSystemBeamLimitingDeviceType(value: any): value is MedicalSystemBeamLimitingDeviceType {
    return Object.values(MedicalSystemBeamLimitingDeviceType).includes(value)
}

